export interface OrgPolicy {
    orgId: string;
    orgTitle: string;
    orgMnemonic: string;
    privacyPolicyUrl: string;
    termAndConditionsUrl: string;

}

export const defaultPolicies: OrgPolicy[] = [
    {
        orgId: '"58b7728f-1051-4ef6-81fe-bdfcdc24972f',
        orgTitle: 'Thiel College',
        orgMnemonic: 'thiel',
        privacyPolicyUrl: 'https://www.thiel.edu/ee2assets/2018-IT_Security_Policy.pdf',
        termAndConditionsUrl: 'https://forms.arirecruiting.com/legal/thiel/sms-terms'
    },
    {
        orgId: '56361727-66fd-4040-8168-ec819168fd2c',
        orgTitle: 'Saint Vincent College',
        orgMnemonic: 'st.vincent',
        privacyPolicyUrl: 'https://www.stvincent.edu/resources/policies/information-and-it-policies/privacy-policy.html',
        termAndConditionsUrl: 'https://forms.arirecruiting.com/legal/st.vincent/sms-terms'
    },
    {
        orgId: 'a1fa74d1-1836-eb11-a970-000d3a4d4c43',
        orgTitle: 'Konstantin Org',
        orgMnemonic: 'konstantin.org',
        privacyPolicyUrl: 'https://www.okta.com/legal/privacy-policy/?_gl=1gegxwv_gcl_auMTY0Mzk2MTUwNC4xNzc0NjAxMzUz_gaMTY0NDQ0MDE2Ni4xNzM2ODMyMjc5_ga_QKMSDV5369*czE3NzQ2MDEzNTMkbzkkZzAkdDE3NzQ2MDEzNTYkajU3JGwwJGgw',
        termAndConditionsUrl: 'https://forms-stage.arirecruiting.com/legal/konstantin.org/sms-terms'
    }];
